import { http } from '@/shared/api/axios';

export interface CredentialValidity {
  userId: number;
  isValid: boolean;
  problems: string[];
}

export const credentialValidityApi = {
  check: async (guardUserIds: number[], throughDate: string): Promise<CredentialValidity[]> => {
    const { data } = await http.post<CredentialValidity[]>(
      '/v1/credential-compliance/validity',
      { guardUserIds, throughDate },
      { _skipErrorToast: true } as never,
    );
    return data;
  },
};
